(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onToggle(event) {
      var details = event.target;
      if (!details || !details.classList || !details.classList.contains('faq-split-section__details')) return;
      var root = details.closest('.faq-split-section');
      if (!root || root.getAttribute('data-faq-split-single') !== 'true') return;
      if (!details.open) return;
      root.querySelectorAll('.faq-split-section__details').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    }

    document.addEventListener('toggle', onToggle, true);

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (!section || !section.querySelector) return;
      var roots = section.querySelectorAll('.faq-split-section');
      roots.forEach(function (root) {
        root.querySelectorAll('.faq-split-section__details').forEach(function (d) {
          d.open = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
